import type { ChangeEventHandler, FocusEventHandler } from 'react';
import { forwardRef } from 'react';

import type { CheckboxButtonGroupProps } from '@capsule/consumer-design-system';
import { CheckboxButtonGroup } from '@capsule/consumer-design-system';

import { getIn, useFormikContext } from 'formik';

export const FormikCheckboxButtonGroup = forwardRef<HTMLFieldSetElement, CheckboxButtonGroupProps>(
  ({ options, ...props }, ref) => {
    const { errors, touched, values, handleBlur, handleChange } = useFormikContext();
    const formikCompatibleOptions = options.map(option => {
      const onBlur: FocusEventHandler<HTMLInputElement> = event => {
        option.onBlur?.(event as any);
        handleBlur(event);
      };

      const onChange: ChangeEventHandler<HTMLInputElement> = event => {
        option.onChange?.(event);
        handleChange(event);
      };

      return {
        ...option,
        error: getIn(touched, option.value) && getIn(errors, option.value),
        checked: !!getIn(values, option.value),
        onBlur,
        onChange,
      };
    });

    return <CheckboxButtonGroup {...props} options={formikCompatibleOptions} ref={ref} />;
  }
);
